import { EditLocalV2EventPage } from "./EditLocalV2EventPage";

export default EditLocalV2EventPage;
